export const deepen = obj => {
    const result = {};

    // for each object path (property key) in the object
    for (const objectPath in obj) {
        // split path into component parts
        const parts = objectPath.split(".");

        // create sub-objects along path as needed
        let target = result;
        while (parts.length > 1) {
            const part = parts.shift();
            target = target[part] = target[part] || {};
        }

        // set value at end of path
        target[parts[0]] = obj[objectPath];
    }

    return result;
};
